import { Trans } from '@lingui/react/macro'
import { ActivityStats } from './ActivityStats'
import { EnrollmentsList } from './EnrollmentsList'

export const Activity = () => {
  return (
    <div className="max-tablet:flex-col flex flex-1">
      <div className="max-tablet:ml-0 max-tablet:pt-4 max-tablet:pb-8 max-mobile:pr-0 ml-4 flex flex-col pt-10 pb-10">
        <div className="max-tablet:static max-tablet:w-full max-tablet:pt-0 sticky top-[var(--header-height)] w-[270px]">
          <div className="max-tablet:pr-0 pr-10">
            <div className="text-subtitle mb-4 font-semibold">
              <Trans>Activity</Trans>
            </div>
            <ActivityStats />
          </div>
        </div>
      </div>
      <div className="max-mobile:px-0 grow pt-10">
        <EnrollmentsList />
      </div>
    </div>
  )
}
